var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.direction == 'desc')?_c('span',[_c('i',{staticClass:"fas fa-sort-down"})]):_c('span',[_c('i',{staticClass:"fas fa-sort-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }